/**
 * API de infra del módulo sync — pull, side-effects, submit online.
 *
 * Estas funciones importan de otros módulos de negocio (catalog, sales, pos,
 * expenses, customers, inventory, etc.) y por eso cierran require cycles contra
 * sync/public-api. Mantenerlas acá permite que los consumidores que solo
 * necesitan tipos/funciones puras importen desde `sync/domain-api` sin disparar
 * la evaluación de este archivo.
 */

// --- Pull customer ---
export { pullCustomerDataFromSupabaseApplication } from './core/pullCustomersUseCase';

// --- Submit command ---
export { submitCommand, type SubmitCommandParams, type SubmitCommandResult } from './core/submitCommand';
